import { CHECKLIST_ITEM_TYPE } from 'src/constants/tasksV2';

export default {
    id: 29,
    type: CHECKLIST_ITEM_TYPE.DATE_FIELD,
    manifestKey: 'DATE_FIELD',

    try_it: {
        button_label: 'Pick Date',
        // Structured-data types fall through to ConfirmationCell (default) in the switch — no dedicated cell exists yet.
        cell_component_import: {
            from: 'src/pages/dashboard/tables/AllLeadTable/TaskChecklistField',
            named: 'ConfirmationCell',
        },
        prefill: {
            completion_state: 'YES',
            response_payload: { date: '2026-05-13' },
        },
    },
    pre_flight_diff: [
        '⚠ value will NOT persist — known bug (BE-#273-cleanup)',
        'PATCH /checklist/{iid}/ with value="<ISO 8601 date>" → 200 but value silently dropped',
        '⚠ Timezone ambiguity: date stored without normalization — display may differ per user timezone',
        'Checklist item: PENDING → YES (via complete POST only)',
        'Date can be stored in response_payload on complete POST (workaround)',
    ],
    has_step2_throttle: false,
    validation_laboratory: [
        {
            label: 'PATCH value="2026-05-13" (silent-drop)',
            body: { value: '2026-05-13' },
            expected: '200 but value not persisted (silent drop) — GET confirms field absent',
        },
        {
            label: 'PATCH value="not-a-date"',
            body: { value: 'not-a-date' },
            expected: '200 accepted — no date format validation, value still silently dropped',
        },
    ],
};
